import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import NewPage from "../views/Newpage.vue";
import Login from "../views/Login.vue";
import ExtraAuth from "../views/ExtraAuth.vue";
import NoAccess from "../views/NoAccess.vue";
import Logout from "../views/Logout.vue";
import LoggedInLayout from "../views/LoggedInLayout.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  }
  ,
  {
    path: "/noaccess",
    name: "noaccess",
    component: NoAccess
  }
  ,
  {
    path: "/logout",
    name: "logout",
    component: Logout
  }
  ,
  
  {
    path: "/ExtraAuth",
    name: "ExtraAuth",
    component: ExtraAuth,
    props: (route) => ({
      user_id: route.query.user_id,
      key: route.query.key,
      app_id: route.query.app_id,
    })
  },
  {
    path: "",
    name: "LoggedInLayout",
    component: LoggedInLayout,
    children: [
      {
        path: "/home",
        name: "home",
        component: Home
      },
      {
        path: "/newpage",
        name: "NewPage",
        component: NewPage
      }
    ]
  }
];

const router = new VueRouter({
  routes
});

export default router;
